
import React from "react";
import { Settings, FileText, Import, FileDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { exportToCSV } from "@/utils/csvUtils";

interface SettingsMenuProps {
  onImportData: () => void;
  onImportBookmarks: () => void;
  onExportBookmarks: () => void;
}

const SettingsMenu: React.FC<SettingsMenuProps> = ({ 
  onImportData, 
  onImportBookmarks,
  onExportBookmarks
}) => {
  const handleExportData = async () => {
    try {
      toast.info("Creating CSV export...");
      await exportToCSV();
    } catch (error) {
      console.error("Export error:", error);
      toast.error("Export failed");
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon" 
          className="rounded-full p-1 hover:bg-accent"
        >
          <Settings className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuItem onClick={handleExportData}>
          <FileText className="mr-2 h-4 w-4" />
          <span>Export to CSV</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onImportData}>
          <FileText className="mr-2 h-4 w-4" />
          <span>Import from CSV</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onImportBookmarks}>
          <Import className="mr-2 h-4 w-4" />
          <span>Import Bookmarks</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onExportBookmarks}>
          <FileDown className="mr-2 h-4 w-4" />
          <span>Export Bookmarks</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default SettingsMenu;
